// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__275vM","productName":"Table_productName__JG9dw"};